// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 989 ? "component---src-core-pages-page-template-tsx" : chunkId) + "-" + {"767":"c7421c0c21068f1042c2","989":"6279cb0fe55824072be1"}[chunkId] + ".js";
};